import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { IntervalSessionService } from '../service/interval-session.service';
import { AuthService } from '../service/auth.service';
import { BroadcastChannelService } from '../service/broadcast-channel.service';

@Component({
  selector: 'app-session-expire',
  templateUrl: './session-expire.component.html',
  styleUrls: ['./session-expire.component.scss'],
  standalone: false
})
export class SessionExpireComponent implements OnInit {
  sessionExpireProgress: number = 0; // Progress bar percentage
  minutesLeft: number = 0; // Minutes left before session expiration
  private readonly dialogTimeout: number = 5 * 60 * 1000; // 5 minutes for dialog auto-logout
  private dialogTimerInterval: any; // Timer for updating dialog progress

  constructor(
    public dialogSessionExpireRef: MatDialogRef<SessionExpireComponent>,
    public intervalSessionService: IntervalSessionService,
    public authService: AuthService,
    private readonly broadcastChannelService: BroadcastChannelService
  ) {
    dialogSessionExpireRef.disableClose = true; // Prevent closing the dialog without action
  }

  ngOnInit(): void {
    // Start the dialog auto-logout timer
    this.startDialogTimer();
  }

  ngOnDestroy(): void {
    clearInterval(this.dialogTimerInterval);
  }

  /**
 * Starts the dialog auto-logout timer and synchronizes it with the progress bar.
 */
  private startDialogTimer(): void {
    const dialogStartTime = Date.now();
    const dialogEndTime = dialogStartTime + this.dialogTimeout;

    this.dialogTimerInterval = setInterval(() => {
      const timeLeft = dialogEndTime - Date.now();

      if (timeLeft <= 0) {
        clearInterval(this.dialogTimerInterval);
        this.onNoClick(); // Auto-logout when the timer expires
        return;
      }

      // Update the progress bar and remaining time for the dialog
      this.minutesLeft = Math.ceil(timeLeft / 60000); // Convert milliseconds to minutes
      this.sessionExpireProgress = Math.max(0, (timeLeft / this.dialogTimeout) * 100);
    }, 1000); // Update every second
  }

  /**
   * Extends the session by calling the IntervalSessionService.
   */
  extendSession(): void {
    this.broadcastChannelService.postMessage('session-extended');
    this.dialogSessionExpireRef.close('extend'); // Close the dialog
  }

  /**
   * Cancels the session by logging the user out.
   */
  onNoClick(): void {
    this.broadcastChannelService.postMessage('logout');
    this.dialogSessionExpireRef.close('logout'); // Close the dialog
  }
}
